export class LanguagesReq{
    languagesId: number;

    constructor(languagesId: number){
        
        languagesId = languagesId;
    }
}